import {Action} from '@ngrx/store';
import {type} from '../../shared/utilities/type';
import {GroupRole} from '../../shared/models/groupe-role';

export const deviceModelsActionTypes = {
  LOAD: type('[Device Models] Load'),
  LOAD_SUCCESS: type('[Device Models] Load Success'),
  LOAD_FAIL: type('[Device Models] Load Server Error')
};

export class LoadDeviceModelsAction implements Action {
  readonly type = deviceModelsActionTypes.LOAD;
  constructor() {}
}

export class LoadDeviceModelsSuccessAction implements Action {
  readonly type = deviceModelsActionTypes.LOAD_SUCCESS;
  constructor(public payload?: GroupRole[]) {}
}

export class LoadDeviceModelsFailAction implements Action {
  readonly type = deviceModelsActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
